export const animateIn = ({ transitionName }) => `
  &.${transitionName}-enter-done, 
  &.${transitionName}-enter-active, 
  &.${transitionName}-appear-done, 
  &.${transitionName}-appear-active
`;

export const animateOut = ({ transitionName }) => `
  &.${transitionName}-exit, 
  &.${transitionName}-enter, 
  &.${transitionName}-appear
`;
